import "../personal.css";

import { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Modal, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import _, { isArray } from "lodash";
import Slider from "react-slick";
import parse from "html-react-parser";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import moment from "moment";

import { Jumbotron } from "sections";
import EnquiryForm from "components/forms/EnquiryForm";
import useStore from "stores/Store";
// import { promotionsContent } from "constants/promotions";
import { LinkButton, NormalButton, PrimaryButton } from "components/buttons";
import { handleOpenPdf } from "utils";

import circle_left from "assets/images/circle_left.svg";
import circle_right from "assets/images/circle_right.svg";
import calendar_icon from "assets/images/calendar_icon.svg";
import gift_icon from "assets/images/gift_icon.svg";

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  nextArrow: <img src={circle_right} alt="circle_right" />,
  prevArrow: <img src={circle_left} alt="circle_left" />,
  adaptiveHeight: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1399,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
        infinite: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        infinite: true,
        centerMode: true,
        centerPadding: "60px",
        nextArrow: null,
        prevArrow: null,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        infinite: true,
        centerMode: true,
        centerPadding: "20px",
        nextArrow: null,
        prevArrow: null,
      },
    },
  ],
};

function PromotionsMain() {
  const { slug } = useParams();
  const promotionHighlightRef = useRef();
  const isMobile = useMediaQuery({ maxWidth: "1024px" });
  const [promotionsContent, setPromotionsContent] = useState([]);
  const [selectedPromo, setSelectedPromo] = useState();
  const navigate = useNavigate();

  const { formRef } = useStore();
  const [isAlert, setIsAlert] = useState(false);
  const [externalLink, setExternalLink] = useState();

  // const sliderRef = useRef(null);

  // useEffect(() => {
  //   if (sliderRef.current) {
  //     setTimeout(() => {
  //       sliderRef.current.slickGoTo(0);
  //     }, 100);
  //   }
  // }, []);

  const handleLinkClick = (event) => {
    const link = event?.target?.closest("a");

    if (link) {
      const url = new URL(link.href);

      if (url.origin !== window.location.origin) {
        // if (url.origin != "https://www.alrajhibank.com.my") {
        event.preventDefault();
        setIsAlert(true);
        setExternalLink(url);
      }
    } else {
      if (typeof event == "string") {
        if (!event?.includes("alrajhibank.com.my")) {
          setIsAlert(true);
          setExternalLink(event);
        } else {
          handleOpenPdf(event);
        }
      }
    }
  };

  useEffect(() => {
    const elements = document.querySelectorAll(".description, .tnc-link");
    elements.forEach((element) => {
      element.addEventListener("click", handleLinkClick);
    });

    return () => {
      elements.forEach((element) => {
        element.removeEventListener("click", handleLinkClick);
      });
    };
  }, [selectedPromo]);

  const fetchPromotionsFromCMS = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/promotion-and-campaigns?sort=createdAt:desc&populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    const found_promotion = promotionsContent.find(
      (item) => item.slug === slug
    );

    if (found_promotion) {
      setSelectedPromo(found_promotion);
    } else {
    }
  }, [promotionsContent, slug]);

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await axios.get(
          "https://www.alrajhibank.com.my/assets/json/promotions.json"
        );

        const cmsPromotions = await fetchPromotionsFromCMS();
        const jsonResponse = response.data;

        setPromotionsContent([...cmsPromotions, ...jsonResponse]);
        setSelectedPromo(cmsPromotions[0]);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchPromotions();
  }, []);

  return (
    <>
      <style>
        {`
          .jumbotron .background-img {
            background: none;
          }
        `}
      </style>
      <Modal
        show={isAlert}
        onHide={() => setIsAlert(false)}
        centered
        size="lg"
        className="alert-modal"
      >
        <Modal.Body>
          <h3>
            <b>You are now leaving alrajhi bank Malaysia website</b>
          </h3>
          <p>
            You are now leaving alrajhi bank Malaysia's (“the Bank”) website. If
            you decide to access any third party websites linked to the Bank’s
            website, you do this entirely at your own risk. The Bank is not
            responsible for nor endorses or shall have any liability arising
            from such sites, products or services offered therein.
          </p>
        </Modal.Body>
        <Modal.Footer
          style={{ border: "none" }}
          className="d-flex justify-content-center flex-nowrap"
        >
          <NormalButton
            text="Close"
            onClick={() => {
              setIsAlert(false);
            }}
            style={{ width: "50%" }}
          />
          <PrimaryButton
            text="Continue"
            onClick={() => {
              window.open(externalLink, "_blank");
              setIsAlert(false);
            }}
            style={{ width: "50%" }}
            id="visit-now"
          />
        </Modal.Footer>
      </Modal>
      <div>
        <section className="section jumbotron">
          <Jumbotron
            badgeText="Promotions"
            title={`Promotions and <span className="jumbotron-subtitle-2">Campaigns</span>`}
            buttonText="Let's Connect"
          />
        </section>

        <div
          className="container promotion-highlight my-5 py-5"
          ref={promotionHighlightRef}
        >
          <Row>
            <Col className="pe-lg-0">
              <div
                className={`d-flex ${
                  isMobile
                    ? "image-container-mobile"
                    : "image-container-desktop"
                }`}
              >
                <img
                  src={
                    selectedPromo?.imageLink
                      ? selectedPromo?.imageLink
                      : selectedPromo?.image
                  }
                  alt="promo"
                  className={isMobile ? "image-mobile" : "image-desktop"}
                />
              </div>
            </Col>
            <Col className="d-flex align-items-center ">
              <div className="px-3 py-4">
                <h2 style={{ color: "#000045", fontWeight: "700" }}>
                  {selectedPromo?.pageTitle
                    ? parse(selectedPromo?.pageTitle || "")
                    : parse(selectedPromo?.title || "")}
                </h2>
                {/* legacy promo */}
                {selectedPromo?.period && (
                  <div className="period">
                    Campaign Period: <span>{selectedPromo?.period}</span>
                  </div>
                )}
                {/* cms promo */}
                {selectedPromo?.startDate && (
                  <div className="period">
                    Campaign Period:{" "}
                    <span>
                      {`${moment(selectedPromo?.startDate).format(
                        "DD MMM YYYY"
                      )} - ${moment(selectedPromo?.endDate).format(
                        "DD MMM YYYY"
                      )}`}
                    </span>
                  </div>
                )}
                <div className="promo-content pe-4 py-4">
                  {selectedPromo?.subtitle && (
                    <div className="subtitle">{selectedPromo?.subtitle}</div>
                  )}
                  {/* legacy promo */}
                  {isArray(selectedPromo?.description) && (
                    <div className="description" style={{ color: "#000045" }}>
                      {selectedPromo?.description.map((desc) => parse(desc))}
                    </div>
                  )}
                  {/* cms promo */}
                  {typeof selectedPromo?.contentTemplate === "string" && (
                    <div className="description" style={{ color: "#000045" }}>
                      {parse(selectedPromo.contentTemplate)}
                    </div>
                  )}
                  {_.has(selectedPromo, "footer") && (
                    <div className="my-4 text-black-50 fs-6">
                      {parse(selectedPromo?.footer)}
                    </div>
                  )}
                  <div className="tnc" style={{ color: "#000045" }}>
                    <p>
                      <b>
                        Visit a branch or connect with us{" "}
                        <span
                          onClick={() =>
                            formRef?.current?.scrollIntoView({ block: "end" })
                          }
                          style={{ color: "blue", cursor: "pointer" }}
                        >
                          here
                        </span>
                      </b>
                    </p>
                    {_.has(selectedPromo, "notes") && (
                      <div className="mt-4 text-black-50 fs-6">
                        {parse(selectedPromo?.notes)}
                      </div>
                    )}
                    {/* legacy promo */}
                    {_.has(selectedPromo, "terms") && (
                      <PrimaryButton
                        style={{ fontSize: "14px" }}
                        text={selectedPromo?.terms?.text}
                        onClick={() =>
                          handleOpenPdf(selectedPromo?.terms?.link)
                        }
                      />
                    )}
                    {/* cms promo */}
                    {_.has(selectedPromo, "tncLink") && (
                      <PrimaryButton
                        style={{ fontSize: "14px" }}
                        text="Terms and Conditions"
                        className="tnc-link"
                        // onClick={() => handleOpenPdf(selectedPromo?.tncLink)}
                        onClick={(e) => handleLinkClick(selectedPromo?.tncLink)}
                      />
                    )}
                  </div>
                  {_.has(selectedPromo, "additionalFooter") && (
                    <div className="mt-4 text-black-50 fs-6">
                      {parse(selectedPromo?.additionalFooter)}
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className="container personal-promotions">
          <h4 className="subheading">Ongoing Promotions</h4>
          <Slider {...settings} 
          // ref={sliderRef}
          >
            {promotionsContent?.map((item, index) => (
              <div
                className="personal-promotion-item"
                onClick={() => {
                  if (item.href) {
                    window.location.href = item.href;
                    return;
                  }
                  if (item.isRizeCampaign) {
                    navigate(`/rize/promotions#${item.slug}`);
                    return;
                  }
                  navigate(`/personal/promotions/${item.slug}`);
                  promotionHighlightRef.current.scrollIntoView();
                }}
              >
                <Card
                  className="card-style"
                  data-aos="fade-left"
                  data-aos-delay={`${item.id + 1}00`}
                >
                  <Card.Img
                    style={{
                      borderTopRightRadius: "20px",
                      borderTopLeftRadius: "20px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    variant="top"
                    src={item.imageLink ? item.imageLink : item.image}
                  />
                  <Card.Body>
                    <div className="d-flex flex-row justify-content-between align-items-center"></div>
                    <div className="title" style={{ color: "#000045" }}>
                      {item.pageTitle
                        ? parse(item.pageTitle || "")
                        : parse(item.title || "")}
                    </div>
                    <div className="d-flex flex-column">
                      <div className="d-flex flex-row align-items-center gap-2">
                        <img
                          src={calendar_icon}
                          height="18px"
                          alt="calendar_icon"
                        />
                        <span
                          className="text-black-50"
                          style={{ paddingLeft: "5px", paddingTop: "2px" }}
                        >
                          {item.period && item.period}
                          {item?.startDate &&
                            `${moment(item?.startDate).format(
                              "DD MMM YYYY"
                            )} to ${moment(item?.endDate).format(
                              "DD MMM YYYY"
                            )}`}
                        </span>
                      </div>
                      <div className="d-flex flex-row align-items-center gap-2">
                        <img src={gift_icon} height="18px" alt="gift_icon" />
                        <span
                          className="text-black-50"
                          style={{ paddingLeft: "5px", paddingTop: "2px" }}
                        >
                          {item.type}
                        </span>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </Slider>
        </div>
        <div className="promotions-main">
          <Container>
            <Row className="my-5 py-5">
              <Col md={4}>
                <h2>Let's connect!</h2>
                <span className="text-black-50">
                  Share your information, and we'll get back to you with the
                  answers you need.
                </span>
              </Col>
              <Col md={8}>
                <EnquiryForm />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default PromotionsMain;
